/* eslint-disable unicorn/no-null */
import React from 'react';
import { useKeyPress } from 'react-use';
import { KEYS } from '@cmctechnology/webinvest-constants';
import { useAuthenticated } from '../hooks/useAuthenticated';
import { useDispatch } from 'react-redux';
import { signInWithUsername } from '../actions';
import { signOut } from '../actions';

export const Authenticated: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { finished, authenticated } = useAuthenticated();
  const [isShiftKeyPressed] = useKeyPress((e) => e.key === KEYS.Shift);
  const dispatch = useDispatch();

  const authenticate = async (username: string, password: string) => {
    dispatch<any>(signInWithUsername(username, password, isShiftKeyPressed));
  };

  if (!finished) return <></>;

  return (
    <>
      <input name='logout' type='button' value='Logout' onClick={() => dispatch<any>(signOut())} data-testid='LoginForm.logout' />
      <br />
      {authenticated ? (
        <>{children}</>
      ) : (
        <form
          data-testid='LoginForm.authForm'
          id='auth-form'
          autoComplete='on'
          onSubmit={async (e) => {
            e.preventDefault();
            // @ts-ignore
            await authenticate(e.target[0].value, e.target[1].value);
          }}
        >
          <input name='username' data-testid='LoginForm.username' />{' '}
          <input name='password' type='password' autoComplete='on' data-testid='LoginForm.password' />{' '}
          <input type='submit' value='Submit' data-testid='LoginForm.loginBtn.Submit' />
        </form>
      )}
    </>
  );
};
